export default "__VITE_ASSET__DN6$vD1N__"